<template>
	<v-dialog persistent v-model="isVisible" max-width="600">
		<p-card class="skill-level-selection overflow-hidden">
			<p-header-dialog @closeClicked="close()">
				Escoge un nivel para tu competencia
			</p-header-dialog>
			<div class="tw-mt-4 tw-flex tw-gap-4">
				<div>
					<span class="tw-text-app-color-primary">Competencia:</span>
				</div>
				<div>
					<span class="tw-text-app-color-secondary">
						<b>{{ skill.name }}</b>
					</span>
					<p class="tw-text-app-color-font tw-leading-text">
						{{ skill.description }}
					</p>
				</div>
			</div>
			<div class="tw-flex tw-flex-col tw-gap-4">
				<div
					v-for="(level, index) in skill.levels"
					:key="index"
					class="tw-flex tw-gap-4 tw-p-4 tw-items-center skill-level-selection--level-box"
					:style="{ borderColor: textToColor(level.name) }"
				>
					<div class="tw-flex-auto">
						<span :style="{ color: textToColor(level.name) }">
							<b>{{ level.name }}</b>
						</span>
						<p
							v-if="level.description"
							class="tw-text-app-color-font tw-leading-text"
						>
							{{ level.description }}
						</p>
					</div>
					<p-button :outlined="true" @click="handleLevelSelection(level)">
						Seleccionar
					</p-button>
				</div>
			</div>
		</p-card>
	</v-dialog>
</template>
<script>
import PButton from '@/modules/shared/components/ui/p-button';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import textToColor from '@/modules/shared/utils/textToColor';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';

export default {
	components: { PHeaderDialog, PButton, PCard },
	props: ['skill'],
	data() {
		return {
			isVisible: false,
		};
	},
	methods: {
		textToColor,
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		handleLevelSelection(level) {
			this.$emit('onLevelSelected', level);
			this.close();
		},
	},
};
</script>

<style scoped lang="scss">
.skill-level-selection {
	&--level-box {
		border-width: 2px;
		border-style: solid;
		border-radius: 5px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/fifth-step/skill-level-selector-dialog.vue